<template>
    <div class="w-full h-full px-[12px] py-[12px]">
        <div class="search flex items-center gap-8px mb-12px">
            <el-input v-model="query" :placeholder="canPreview ? '' : '输入文字或粘贴图片链接'" clearable
                :class="canPreview ? 'show-image' : ''">
                <template #prefix>
                    <img v-if="canPreview" :src="imageSrc" class="input-thumb" />
                    <el-icon v-else>
                        <Search />
                    </el-icon>
                </template>
            </el-input>
            <el-button type="primary" @click="searchimg">搜索</el-button>
        </div>
        <el-popover placement="bottom-start" :width="220" trigger="click" :show-arrow="false"
            v-model:visible="sourceVisible">
            <template #reference>
                <div class="source-ref">
                    <el-icon class="mr-6px">
                        <Collection />
                    </el-icon>
                    <span class="source-text">{{ defaultSource?.name || '素材源' }}</span>
                    <el-icon class="caret">
                        <ArrowDown />
                    </el-icon>
                </div>
            </template>
            <div class="source-content">
                <div class="source-item" v-for="item in sourceList" :key="item.id" @click="selectSource(item)"
                    :class="{ active: defaultSource?.id === item.id }">
                    <span>{{ item.name }}</span>
                    <el-icon v-if="defaultSource?.id === item.id"><Select color="#2a66ff" /></el-icon>
                </div>
            </div>
        </el-popover>
        <div class="cont">
            <template v-if="searchLoading">
                <div class="listcont">
                    <div class="listitem" v-for="n in 30" :key="'sk-' + n">
                        <el-skeleton animated>
                            <template #template>
                                <el-skeleton-item variant="image" class="skeleton-img" />
                            </template>
                        </el-skeleton>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="listcont" v-if="searchResultList && searchResultList.length">
                    <div class="listitem" v-for="item in searchResultList" :key="item.id">
                        <imageSearchItem :template="item" />
                    </div>

                </div>
                <div v-else>
                    <el-empty description="暂无搜索结果" />
                </div>
                <div class="w-full">
                    <div class="more-wrap" v-if="showMore && !loadingMore">
                        <div class="more-btn" @click="onMore">更多</div>
                    </div>
                    <div class="more-wrap" v-else-if="loadingMore">
                        <div class="more-loading">加载中...</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { ElInput, ElPopover, ElIcon, ElButton, ElSkeleton, ElSkeletonItem, ElEmpty } from 'element-plus'
import { Search, ArrowDown, Collection, Link, Select } from '@element-plus/icons-vue'
import { on as busOn, off as busOff, getLast } from '@/utils/eventBus'
import { getMaterialSources, searchMaterialSources } from '@/api/affairs'
// @ts-ignore
import imageSearchItem from './imageSearchItem.vue'
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()
const query = ref('')
const canPreview = ref(false)
const imageSrc = computed(() => {
    const v = typeof query.value === 'string' ? query.value.trim() : ''
    return canPreview.value ? v : ''
})
const exts = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'svg', 'bmp']

let loader: HTMLImageElement | null = null
watch(query, (val) => {
    const s = typeof val === 'string' ? val.trim() : ''


    if (!s) { canPreview.value = false; loader = null; return }
    // if (!looksLikeImageUrl(s)) { canPreview.value = false; loader = null; return }

    const img = new Image()
    loader = img
    try { img.crossOrigin = 'anonymous' } catch { }
    img.onload = () => { if (loader === img) canPreview.value = true }
    img.onerror = () => { if (loader === img) canPreview.value = false }
    img.src = s
}, { immediate: true })

const handleSetURL = (url: any) => {
    if (typeof url === 'string') {
        query.value = url
    } else {
        query.value = String(url ?? '')
    }
    getSourceList()
}
onMounted(() => {
    busOn('imageSearch:setURL', handleSetURL)
    getSourceList()
    const last = getLast('imageSearch:setURL')
    handleSetURL(last)

})
onBeforeUnmount(() => {
    busOff('imageSearch:setURL', handleSetURL)
})
const defaultSource = ref<any>({})
const sourceVisible = ref(false)
const sourceList = ref<any[]>([])
const getSourceList = () => {
    getMaterialSources({}).then((res) => {
        sourceList.value = res.data.data || []
        defaultSource.value = sourceList.value[0]
        currentPage.value = 1
        search()
    })
}
const selectSource = (item: any) => {
    if (searchLoading.value || loadingMore.value) return
    defaultSource.value = item
    sourceVisible.value = false
    currentPage.value = 1
    search()
}
const searchResultList = ref<any[]>([])
const searchLoading = ref(false)
const loadingMore = ref(false)
const pageSize = ref(30)
const currentPage = ref(1)
const lastCount = ref(0)
const showMore = computed(() => lastCount.value === pageSize.value)
const searchimg = () => {
    currentPage.value = 1
    search(false)
}
const search = (next = false) => {

    if (searchLoading.value || loadingMore.value) return
    if (next) {
        loadingMore.value = true
    } else {
        searchLoading.value = true
    }
    currentPage.value = next ? currentPage.value + 1 : 1
    searchMaterialSources({
        file: query.value,
        id: defaultSource.value.id,
        page: currentPage.value,
        pageSize: pageSize.value,
        corp_code: userStore.currentTeamInfo?.corp_id || '',
    }).then((res) => {
        const list = res.data?.data?.list || []
        lastCount.value = list.length
        if (next) {
            searchResultList.value = (searchResultList.value || []).concat(list)
        } else {
            searchResultList.value = list
        }
    }).finally(() => {
        if (next) {
            loadingMore.value = false
        } else {
            searchLoading.value = false
        }
    })
}
const onMore = () => search(true)
</script>
<style scoped>
.input-thumb {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    object-fit: cover;
}

.show-image :deep(.el-input__inner) {
    color: transparent;
    caret-color: transparent;
}

.source-ref {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 12px;
    border-radius: 8px;
    background: #f5f7fa;
    color: #38393b;
    cursor: pointer;
}

.source-ref:hover {
    background: #eef1f5;
}

.source-text {
    font-size: 14px;
}

.caret {
    margin-left: 6px;
}

.source-content {
    background: #fff;
    border-radius: 12px;
    padding: 8px;
}

.source-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 10px;
    border-radius: 8px;
    cursor: pointer;
}

.source-item:hover {
    background: #f5f7fa;
}

.source-item.active {
    background: #eef1f5;
    color: #2a66ff;
}

.tag {
    font-size: 12px;
    color: #8a8f99;
    background: #f0f2f5;
    border-radius: 10px;
    padding: 2px 6px;
}

.listcont {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    width: 100%;
    margin-top: 16px;
}

.cont {
    height: calc(100vh - 180px);
    overflow: auto;
}

.skeleton-img {
    width: 100%;
    height: 90px;
    border-radius: 8px;
}

.more-wrap {
    display: flex;
    justify-content: center;
    margin: 12px 0 4px;
}

.more-btn {
    min-width: 80px;
    height: 30px;
    padding: 0 16px;
    border-radius: 6px;
    background: #f5f7fa;
    color: #38393b;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.more-btn:hover {
    background: #eef1f5;
}
</style>
